import { render, staticRenderFns } from "./OrderDetailsShipping.vue?vue&type=template&id=33f64ae8&"
import script from "./OrderDetailsShipping.vue?vue&type=script&lang=js&"
export * from "./OrderDetailsShipping.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailsShipping.vue?vue&type=style&index=0&id=33f64ae8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports